import { BeeModals } from './containers'
import { Container } from 'semantic-ui-react'
import BeeMenu from './containers/BeeMenu'
import BeeRoutes from './containers/BeeRoutes'

const Content = (props) => {
  const { location } = props
  return (
    <Container className='outer'>
      <BeeModals />
      <BeeMenu {...location} />
      <BeeRoutes />
    </Container>
  )
}

export default Content
